import React, { useRef, useCallback, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { ApprovedDateHandler, CustomerEmailHandler, KycStatusHandler, RegisteredDateHandler, StatusHandler } from './service';
import List from '../grid.component';
const CustomersGrid = ((props) => {
  const gridRef = useRef(null);
  const navigate = useNavigate();
  const [checkboxSelection, setCheckboxSelection] = useState([]);
  const [checkBoxData, setCheckBoxData] = useState({})
  const [copiedId, setCopiedId] = useState('');

  const customerDetailsHandler = useCallback((data) => {
    navigate(`/customer/${data?.id}/customerCards`)
  }, [])

  useEffect(() => {
    if (props?.onActionClick) {
      handleToolBarActions('Add');
    }
  }, [props?.onActionClick])

  const handleCheckboxChanges = useCallback(
    (prop, e) => {
      props?.setError(null);
      if (e.target.checked) {
        const rowChecked = prop.dataItem;
        let _selection = [...checkboxSelection];
        let idx = _selection.indexOf(rowChecked.id);
        if (checkboxSelection) {
          _selection = [];
        }
        if (idx > -1) {
          _selection.splice(idx, 1);
        } else {
          _selection.push(rowChecked.id);
        }
        setCheckBoxData(rowChecked);
        setCheckboxSelection(_selection);
      } else {
        setCheckBoxData({});
        setCheckboxSelection([]);
      }
    }, [checkboxSelection]);

  const handleToolBarActions = (action) => {
    if (!checkBoxData?.id) {
      props?.setError("Please select one record!")
      return;
    }
    if (action?.toLowerCase() === 'add') {
      navigate(`/customers/${checkBoxData?.id}/createcase`);
    }
  }
  const handleIdCopy = useCallback((id) => {
    setCopiedId(id);
    setTimeout(() => {
      setCopiedId('');
    }, 300)
  }, [])

  const customerEmailHandler = useCallback((props) => {
    return <CustomerEmailHandler data={props?.dataItem} handleIdCopy={handleIdCopy} copiedId={copiedId} customerDetailsHandler={customerDetailsHandler} />
  }, [copiedId, handleIdCopy, customerDetailsHandler])

  const kycStatusHandler = useCallback((props) => {
    return <KycStatusHandler data={props?.dataItem} />
  }, [])

  const statusHandler = useCallback((props) => {
    return <StatusHandler data={props?.dataItem} />
  }, [])

  const registerDateHandler = useCallback((props) => {
    return <RegisteredDateHandler data={props?.dataItem} />
  }, [])

  const approvedDateHandler = useCallback((props) => {
    return <ApprovedDateHandler data={props?.dataItem} />
  }, [])

  const customcells = {
    "kycorkybVerified": kycStatusHandler,
    "registerDate": registerDateHandler,
    "approvedDate": approvedDateHandler,
    "state": statusHandler,
    "email": customerEmailHandler,
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells])
  return (
    <div>
      <List
        url={process.env.REACT_APP_GRID_API + `api/KycService/customersK`}
        additionalParams={props?.filterValues}
        pSize={10}
        className="custom-grid"
        ref={gridRef}
        showExcelExport={props?.isExcelExport}
        screenName={'Customer'}
        pKey={"Customers"}
        renderCustomCell={renderCustomCell}
        handleSelection={handleCheckboxChanges}
        showGridSelection={true}
        selection={[checkBoxData?.id]}
        ignoreSaved={true}
      />
    </div>
  )
})
export default React.memo(CustomersGrid)
